import { reactive } from 'vue';

export const store = reactive({
  productOfTradeCollection: [],
  aberturaCaixa: false,
  verificaEstoque: false,
  pafNFCe: false,
});
